import { useMemo } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { Helmet } from "react-helmet";
import { FormProvider } from "react-hook-form";
import { QueryClient, QueryClientProvider } from "react-query";
import { ControlledThemeProvider } from "@circle-react/providers";
import { reactQueryConfig } from "@circle-react/providers/QueryClient/reactQueryConfig";
import type { CheckoutProps } from "./CheckoutProps";
import { CheckoutWithPMC } from "./CheckoutWithPMC";
import { CheckoutWithoutPMC } from "./CheckoutWithoutPMC";
import { useCheckoutBodyClasses } from "./hooks/useCheckoutBodyClasses";
import { useCheckoutFormMethods } from "./hooks/useCheckoutFormMethods";
import { useCheckoutTitle } from "./hooks/useCheckoutTitle";

export const Checkout = (props: CheckoutProps) => {
  const queryClient = useMemo(() => new QueryClient(reactQueryConfig), []);

  const { currentCommunityProcessorPaymentMethodConfigurationId } = props;

  let CheckoutComponent;
  if (currentCommunityProcessorPaymentMethodConfigurationId) {
    CheckoutComponent = CheckoutWithPMC;
  } else {
    CheckoutComponent = CheckoutWithoutPMC;
  }

  const title = useCheckoutTitle(props);
  useCheckoutBodyClasses(props);
  const formMethods = useCheckoutFormMethods(props);

  if (!CheckoutComponent) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <ControlledThemeProvider>
        <QueryClientProvider client={queryClient}>
          <NiceModal.Provider>
            <FormProvider {...formMethods}>
              <CheckoutComponent {...props} />
            </FormProvider>
          </NiceModal.Provider>
        </QueryClientProvider>
      </ControlledThemeProvider>
    </>
  );
};
